import * as React from "react";
import { NavLink } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import { Trad } from "src/components";

export const GetBindersListColumns = () => [
    {
        name: "ID_Binder",
        label: "ID",
        options: {
            filter: false
        }
    },
    {
        name: "CodiceBinder",
        label: Trad.Trad("Codice binder"),
        options: {
            filter: false
        }
    },
    {
        name: "AnagDa",
        label: Trad.Trad("Da"),
        options: {
            filter: false
        }
    },
    {
        name: "AnagA",
        label: Trad.Trad("A"),
        options: {
            filter: false
        }
    },
    {
        name: "DataEffetto",
        label: Trad.Trad("Data effetto"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val || "")
        }
    },
    {
        name: "DataFine",
        label: Trad.Trad("Data fine"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val || "")
        }
    },
    {
        name: "DataStipula",
        label: Trad.Trad("Data stipula"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val || "")
        }
    },
    {
        name: "ID_Binder",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string) => (
                <a href={`/binder/${val}`}>
                    <Tooltip title={Trad.Trad("Modifica")}>
                        <IconButton aria-label="edit" size="small">
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                </a>
            )
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/BindersList/BindersListColumns.tsx